import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './editor-layout.component.html'
})
export class EditorLayoutComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/layouts/editor/editor-layout.component.ts